import { render, staticRenderFns } from "./AddResource.vue?vue&type=template&id=62908301&scoped=true&"
import script from "./AddResource.vue?vue&type=script&lang=js&"
export * from "./AddResource.vue?vue&type=script&lang=js&"
import style0 from "./AddResource.vue?vue&type=style&index=0&id=62908301&lang=scss&scoped=true&"
import style1 from "./AddResource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62908301",
  null
  
)

export default component.exports